<template>
  <div class="main">
    <div class="wrapper">
      <div class="navigation">
        <router-link to="/boleto/dados-boleto"><img :src="icBack" /></router-link>
        <span>Boletos</span>
        <router-link to="/home"><img :src="icClose" /></router-link>
      </div>
      <div class="content">
        <p>Selecione a opção de parcelamento</p>
        <div class="info border">
          <span class="badge">Parcelamento</span>

          <div class="list scroll">
            <div v-for="option in creditOptions" :key="option.id" class="item border parcela">
              <input type="checkbox" :id="option.id" :checked="installmentChecked.id === option.id"
                @change="handleCheckboxChange(option)" :value="option.value" v-if="option.id >= 0" />
              <label :for="option.id" :class="{ selected: selectedOptions.includes(option.id) }"
                v-if="option.id >= 0">{{ option.label }}</label>
              <small v-if="option.id >= 0">R$ {{ option.totalParcela }}</small>
            </div>
          </div>
        </div>
        <img :src="next" class="nextStep" @click="handleNextStepClick" />
      </div>

      <FooterGlobal></FooterGlobal>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import icNext from '@/assets/svg/ic-next.svg'
import icClose from '@/assets/svg/ic-close.svg'
import icBack from '@/assets/svg/ic-back.svg'
import FooterGlobal from '@/components/Footer.vue'
import axios from 'axios'
import { timerToReturnToHome } from '@/helper/timer'

export default defineComponent({
  name: 'ParcelaBoleto',
  components: {
    FooterGlobal,
  },
  data() {
    timerToReturnToHome(40000)
    return {
      next: icNext,
      icClose: icClose,
      icBack: icBack,
      selectedOptions: [],
      installmentChecked: {},
      creditOptions: [],
      sessionStorageData: JSON.parse(
        sessionStorage.getItem('dadosBoleto') || '{}',
      ),
    }
  },
  methods: {
    async fetchParcelOptions() {

      const username = process.env.VUE_APP_IPAG_API_USER
      const password = process.env.VUE_APP_IPAG_API_PASSWORD
      const url = process.env.VUE_APP_API_URL
      const basicAuth = btoa(`${username}:${password}`)

      try {
        const response = await axios.post(
          `${url}/totem/tabelaBoleto.php`,
          {
            valor: this.sessionStorageData.originalAmount / 100,
          },
          {
            headers: {
              Authorization: `Basic ${basicAuth}`,
              'Content-Type': 'application/json',
            },
          },
        )

        if (response.data.status === true) {
          this.creditOptions = response.data.dados.map((option) => {
            const parcelas = Number(option.numParcelas)

            return {
              id: parcelas,
              label: parcelas === 0 ? 'Pagamento 1x' : `Crédito ${parcelas}x`,
              value: parcelas === 0 ? 'Pagamento 1x' : `Crédito ${parcelas}x`,
              installments: parcelas === 0 ? 1 : parcelas, // se precisar mandar 1 pro backend
              totalParcela: Number(option.totalParcela).toFixed(2),
            }
          })
        } else {
          console.error('Erro na resposta do servidor')
        }
      } catch (error) {
        console.error('Erro ao fazer a solicitação HTTP', error)
      }
    },
    getCreditValue() {
      return (this.sessionStorageData.originalAmount / 100).toFixed(2)
    },

    handleCheckboxChange(option) {
      this.installmentChecked = option
    },

    handleNextStepClick() {
      if (this.installmentChecked.id === undefined || this.installmentChecked.id === null) {
        alert('Selecione uma opção para prosseguir')
        return
      }

      // Salvar a quantidade de parcelas selecionada em sessionStorage
      sessionStorage.setItem('selectedInstallments', this.installmentChecked.id)

      // Salvar o valor correspondente ao label selecionado em sessionStorage em caixa alta
      const selectedOption = this.creditOptions.find(
        (option) => option.id === this.installmentChecked.id,
      )
      if (selectedOption) {
        const selectedValueInUpperCase = selectedOption.label.toUpperCase()
        sessionStorage.setItem(
          'selectedInstallmentValue',
          selectedValueInUpperCase,
        )
      }

      // if (this.installmentChecked.value === 'pix') {
      //   this.$router.push('/debito/pagamento-debito-veicular-pix')
      // }
      if (this.installmentChecked.id === 0) {
        sessionStorage.setItem(
          'installmentSelect',
          JSON.stringify(this.installmentChecked),
        )
        this.$router.push('/boleto/pagamento-boleto-1x')
      } else {
        sessionStorage.setItem(
          'installmentSelect',
          JSON.stringify(this.installmentChecked),
        )
        this.$router.push('/boleto/pagamento-boleto-cartao')
      }
    },
  },
  mounted() {
    // Chame a função para buscar as opções de parcelamento quando o componente for montado
    this.fetchParcelOptions()
  },
})
</script>
